
<!-- Toolbar -->
<div class="toolbar" role="banner">

  <img
    width="40"
    alt="Logo"
    src="assets/CosmEthics_Logo_C.png"
  />
  <nav>
    <button mat-button routerLink="/" routerLinkActive="active">Home</button>
    <button mat-button (click)="usefulFunctionsService.goTo('/products-data')">Products Data</button>
    <button mat-button (click)="usefulFunctionsService.goTo('/inci-details')">Ingredient Taxonomy</button>
    <button mat-button (click)="usefulFunctionsService.goTo('/inci-alerts')">INCI Alerts</button>
    <button mat-button (click)="usefulFunctionsService.goTo('/recommendations')">Recommendations</button>

  </nav>

</div>

<router-outlet></router-outlet>
